module.exports = __webpack_public_path__ + "static/media/totally_wowed_3.bc692cf0.svg";